import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { DescontoService } from '../../desconto/desconto.service';

import { GrupoDesconto } from '../../desconto/models/desconto';
import { Produto, ProdutoEstoque } from '../models/produto';
import { ProdutoService } from '../produto.service';

@Component({
  selector: 'app-produto-estoque-list',
  templateUrl: './produto-estoque-list.component.html',
  styleUrls: ['./produto-estoque-list.component.scss']
})
export class ProdutoEstoqueListComponent implements OnInit {

    public listaProduto: ProdutoEstoque[];    
    public produto: ProdutoEstoque;
    public idProduto: number;
    public listaDescontoGrupo: GrupoDesconto[] = [];
    public selectedDescontoGrupo: GrupoDesconto;
    public codProduto: string;
    public isDisableProduto: boolean = false;

    public submitted: boolean;
    public displayMsg: boolean = false;
    public displayDialog: boolean;
    public displayDialogImport:boolean;
    globalFilterValue: string = '';
    public produtoDet: any = {};
    displayDetalhes: boolean = false;


    constructor(public produtoService: ProdutoService, 
        private descontoService: DescontoService,
        private router: Router, 
        private messageService: MessageService, 
        private confirmationService: ConfirmationService,
        private notificationService: NotificationsService) { }

    ngOnInit(): void {
        this.getProdutos();
        this.getDescontos();
    }


    getProdutos() {

        this.produtoService.getProdutosEstoque().subscribe(
            (res) => {
                if (res) {
                    this.listaProduto = res;
                }
            },
            err => {
                console.log("ProdutoList - Produtos");
                console.log(err);
            }
        );
    }


    getDescontos() {

        this.descontoService.getGruposDesconto().subscribe(
            (res) => {
                if (res) {
                    this.listaDescontoGrupo = res;
                }
            },
            err => {
                console.log("ProdutoList - Descontos");
                console.log(err);
            }
        );
    }

    

      addProduto() {
        this.produto = {};
        this.submitted = false;
        this.displayDialog = true;
      } 

    editProduto(produto: ProdutoEstoque) {
        //this.selectedDescontoGrupo = this.getSelectedDesconto(produto.idGrupoDesconto);            
        this.produto = { ...produto };  
       // if (this.produto.idSistemaOrigem === this.produto.cdInterno)
        //    this.isDisableProduto = true;
        this.displayDialog = true;
    }

    getSelectedDesconto(idDesconto: number) {
        return this.listaDescontoGrupo.find(x => x.idGrupoDesconto === idDesconto);
      }
    
      SetDesconto(idGrupoDesconto: number)
      {
       // this.produto.idGrupoDesconto = idGrupoDesconto;        
      }

    hideDialog() {
        this.displayDialog = false;
        this.submitted = false;        
        this.selectedDescontoGrupo = {};
        this.isDisableProduto = false;
    }
    
    saveProduto() {
        this.submitted = true;
        
        this.isDisableProduto = false;
    }

    importar(){
        this.displayDialogImport = true;
    }

    limparFiltros(table: any) {
      this.globalFilterValue = ''; 
  table.clear(); // limpa filtros + ordenação + busca global
}


    importarProduto(){
        if(!this.codProduto){
            this.notificationService.toastNotify('error','Importação de produto', 'Produto não informado!');
            return;
                
        }
        this.produtoService
        .importProduto(this.codProduto)
        .subscribe(
            () => {
                this.notificationService.toastNotify('success','Importação de produto', 'Produto importado com sucesso!');
                
                this.getProdutos()
                
            
            },
            err => console.log(err)
        );
        this.displayDialogImport = false;
        this.codProduto=null;
    }

    detalhesProduto(idProduto){
      this.produtoService
        .getProduto(idProduto)
        .subscribe(
            (p) => {
                
                this.produtoDet = p;
                this.displayDetalhes = true; // 🔥 abre modal
            
            },
            err => console.log(err)
        );
    }

}
